import { gql } from '@apollo/client';

export default gql`
  mutation DeletePanelTagMutation($panelTagId: Int!) {
    deletePanelTagById(input: { id: $panelTagId }) {
      tagByTagId {
        id
      }
    }
  }
`;
